export default __webpack_public_path__ + "static/media/data-visualization-with-python.406b31e6.png";